<script lang="ts">
  import CategorySection from './CategorySection.svelte'
  import filters from '../lib/stores/filters'
  import useFilter from '../hooks/use-filter'
  import Flatpickr from './Flatpickr.svelte'
  import Category from './Category.svelte'
  import 'flatpickr/dist/flatpickr.css'
  import Label from './Label.svelte'

  // flatpickr instance
  let dateToFlatpickr: unknown
  let dateFromValue: string = ''
  let dateToValue: string = ''

  const DATE_FORMAT = 'd.m.Y'
  const { resetTermCategory } = filters
  const { categories } = useFilter()
  const { id, label, placeholders } = categories.term

  const flatpickrOptions = {
    allowInput: true,
    disableMobile: true,
    altFormat: DATE_FORMAT,
    dateFormat: DATE_FORMAT,
    monthSelectorType: 'static',
  }

  const updateStore = () => {
    if (dateFromValue && dateToValue) {
      filters.update((value) => ({
        ...value,
        dateFrom: dateFromValue,
        dateTo: dateToValue,
      }))
    }
  }

  const onChangeFrom = (event) => {
    ;[, dateFromValue] = event.detail
    // @ts-ignore
    const dateFrom: Date = dateToFlatpickr.parseDate(dateFromValue, DATE_FORMAT)
    // @ts-ignore
    const dateTo: Date = dateToFlatpickr.parseDate(dateToValue, DATE_FORMAT)

    if (!dateToValue) {
      dateToFlatpickr.open()
    } else if (dateFrom > dateTo) {
      // @ts-ignore
      dateToFlatpickr.setDate(dateFrom, true, DATE_FORMAT)
      dateToFlatpickr.open()
    }
    updateStore()
  }

  const onChangeTo = (event) => {
    ;[, dateToValue] = event.detail
    updateStore()
  }
</script>

<Category {id} on:reset={resetTermCategory}>
  <CategorySection>
    <Label class="block pb-4" as="div">
      {label}
    </Label>
    <section class="m-auto flex flex-col gap-x-8 gap-y-4 sm:flex-row lg:w-9/12">
      <Flatpickr
        class="input"
        name="od_date"
        options={{
          ...flatpickrOptions,
          minDate: 'today',
          defaultDate: $filters.dateFrom,
        }}
        placeholder={placeholders.from}
        data-label={placeholders.from}
        value={$filters.dateFrom}
        on:change={onChangeFrom}
      />
      <Flatpickr
        class="input"
        name="do_date"
        options={{
          ...flatpickrOptions,
          minDate: dateFromValue || 'today',
        }}
        placeholder={placeholders.to}
        data-label={placeholders.to}
        value={$filters.dateTo}
        on:change={onChangeTo}
        bind:flatpickr={dateToFlatpickr}
      />
    </section>
  </CategorySection>
</Category>
